import styled from 'styled-components';
import { SectionParent } from '../../../components/StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import transport from '../../../assets/v2/Product/transport.svg';
import education from '../../../assets/v2/Product/education.svg';
import health from '../../../assets/v2/Product/health.svg';
import hospital from '../../../assets/v2/Product/hospital.svg';
import restaurant from '../../../assets/v2/Product/restaurant.svg';
import retail from '../../../assets/v2/Product/retail.svg';
import inspire from '../../../assets/v2/Product/inspire.png';
import spire from '../../../assets/v2/Product/spire.png';
import { navigate } from 'gatsby';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-image: linear-gradient(
    to top,
    #ffffff,
    #f4f6fb 5%,
    #f4f6fb 27%,
    #ffffff 27%,
    #ffffff 27%
  );
  padding-top: 6rem !important;
  padding-bottom: 8rem !important;
  @media (max-width: 1100px) and (min-width: 800px) {
    padding: 0 1rem;
  }
  @media (max-width: 520px) {
    background-image: none;
    background: #ffffff;
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const Heading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  padding: 0 10rem;
  padding-bottom: 2rem;
  color: #4f5263;
  @media (max-width: 520px) {
    font-size: 14px;
    padding: 0rem;
    padding-bottom: 2rem;
  }
`;

const UsesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-radius: 113px;
  background-color: #f4f6fa;
  padding: 2rem 6rem;
  width: 90%;
  @media (max-width: 800px) {
    border-radius: 10px;
  }
  @media (max-width: 520px) {
    padding: 2rem;
    width: 100%;
  }
`;
const UsesItem = styled.div`
  display: grid;
  grid-column: span 1;
  @media (max-width: 1100px) {
    grid-column: span 2;
  }
  @media (max-width: 520px) {
    grid-column: span 3;
  }
`;

const ImageWrapper = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  min-height: 6rem;
  @media (max-width: 800px) {
    min-height: 5rem;
  }
`;

const ImageLogo = styled(ImageWrapper)`
  min-height: 0 !important;
`;
const StyledImg = styled(LazyLoadImage)`
  height: fit-content;
  max-width: 60px;
  max-height: 64px;
`;

const UsesText = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  text-align: center;
  min-height: 4rem;
`;

const CustomerHeading = styled.div`
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.52;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  padding: 3rem 0;
`;

const CompanyContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 60%;
  grid-gap: 2rem;
  @media (max-width: 800px) {
    width: 75%;
    grid-template-columns: repeat(1, 1fr);
  }
`;

const CompanyItem = styled.div`
  display: block;
  grid-column: span 1;
  padding: 2rem;
  border-radius: 4px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  cursor: pointer;
  transition: transform 0.3s ease-in;
  :hover {
    transform: scale(1.05);
  }
  @media (max-width: 800px) {
    grid-column: span 2;
  }
  @media (max-width: 520px) {
    padding: 2rem;
    padding-bottom: 2rem;
  }
`;

const CardHeading = styled.div`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  padding-bottom: 1rem;
`;

const StyledImgLogo = styled(LazyLoadImage)`
  height: 6rem;
  width: auto;
  max-width: 100%;
  object-fit: scale-down;
`;

const CardContent = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  text-align: center;
  padding-top: 1rem;
  min-height: 8rem;
`;

export default class ProductSectionFive extends React.Component<any, any> {
  render() {
    return (
      <Section>
        <Heading>
          {this.props?.messages?.HomePageHowCustomersUseEsperTitle}
        </Heading>
        <SubHeading>
          {this.props?.messages?.HomePageHowCustomersUseEsperDesc1}
        </SubHeading>
        <UsesContainer>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={education} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperEd}
            </UsesText>
          </UsesItem>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={retail} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperRetail}
            </UsesText>
          </UsesItem>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={restaurant} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperResto}
            </UsesText>
          </UsesItem>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={transport} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperTransportation}
            </UsesText>
          </UsesItem>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={hospital} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperHospitality}
            </UsesText>
          </UsesItem>
          <UsesItem>
            <ImageWrapper>
              <StyledImg src={health} />
            </ImageWrapper>
            <UsesText>
              {this.props?.messages?.HomePageHowCustomersUseEsperHealthcare}
            </UsesText>
          </UsesItem>
        </UsesContainer>

        <CustomerHeading>
          {this.props?.messages?.HomePageHowCustomersUseEsperDesc21}
          <br />
          {this.props?.messages?.HomePageHowCustomersUseEsperDesc2}
        </CustomerHeading>
        <CompanyContainer>
          <CompanyItem
            id="homepage_healthcare_banner"
            onClick={() => navigate('/healthcare')}
          >
            <CardHeading>
              {this.props?.messages?.HomePageHowCustomersUseSpireHealthTitle}
            </CardHeading>
            <ImageLogo>
              <StyledImgLogo src={spire} />
            </ImageLogo>
            <CardContent>
              {this.props?.messages?.HomePageHowCustomersUseSpireHealthDesc}
            </CardContent>
          </CompanyItem>
          <CompanyItem
            id="homepage_retail_banner"
            onClick={() => navigate('/retail-device-management')}
          >
            <CardHeading>
              {this.props?.messages?.HomePageHowCustomersUseInSpireHealthTitle}
            </CardHeading>
            <ImageLogo>
              <StyledImgLogo src={inspire} />
            </ImageLogo>
            <CardContent>
              {this.props?.messages?.HomePageHowCustomersUseInSpireHealthDesc}
            </CardContent>
          </CompanyItem>
          {/* <CompanyItem>
            <CardHeading>Hospitality</CardHeading>
            <ImageLogo>
              <StyledImgLogo src={intelity} />
            </ImageLogo>
            <CardContent>
              Intelity, a leading hospitality ISV, uses Esper’s platform to
              drive operational efficiency at globally-known hoteliers.
            </CardContent>
          </CompanyItem> */}
        </CompanyContainer>
      </Section>
    );
  }
}
